import type { RouteLocationRaw } from "vue-router";

/**
 * The deal page, optionally deep-linked to one of its deliveries: the page reads `?delivery=` to
 * expand that delivery and scroll to it.
 */
export function dealRoute(
  dealId: number,
  deliveryId?: number | null
): RouteLocationRaw {
  return {
    name: "ForwardsDeal",
    params: { id: String(dealId) },
    query:
      deliveryId === undefined || deliveryId === null
        ? {}
        : { delivery: String(deliveryId) },
  };
}
